import axios from "axios";

export function GetApi(path) {
    const GetApiData = axios
        .get(path)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.error(error);
            return error.response;
        });

    return GetApiData;
}
export function GetTokenApi(path) {
    let token = "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyaWQiOiIwZ2Y1N2FiOC02MGY1LTQ4NmMtYmIzZS0wMGI2NThlMTk0OWEiLCJpcCI6Ijk1LjIxNi4xOC4xMzAiLCJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9lbWFpbGFkZHJlc3MiOiJtYW5hZ2VyQGdtYWlsLmNvbSIsInN1YiI6IjBnZjU3YWI4LTYwZjUtNDg2Yy1iYjNlLTAwYjY1OGUxOTQ5YSIsImh0dHA6Ly9zY2hlbWFzLm1pY3Jvc29mdC5jb20vd3MvMjAwOC8wNi9pZGVudGl0eS9jbGFpbXMvcm9sZSI6WyJNYW5hZ2VyIiwiRXhlY3V0aXZlIl0sIlBlcm1pc3Npb24iOiJQZXJtaXNzaW9ucy5Vc2Vycy5WaWV3IiwiZXhwIjoxNzQ4NDMyOTAyLCJpc3MiOiJDb3JlSWRlbnRpdHkiLCJhdWQiOiJDb3JlSWRlbnRpdHlVc2VyIn0.wRJorLiWxefFg5oh0zhENTiuyTPZP76BRKPQ30sETio";
    // let token = "Bearer " + localStorage.getItem("accessToken");
    let headers = { Authorization: token };
    const GetApiData = axios
        .get(path, { headers: headers })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            if (error.message === "Network Error") {
                localStorage.removeItem("accessToken");
                window.location.href = "/";
            }
            return error.response;
        });

    return GetApiData;
}

export function PostApi(path, body) {
    const PostApiData = axios
        .post(path, body)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            if (error.response) {
                console.error("Error Response:", error.response); // The server responded with a status code outside of the range 2xx
                return error.response; // You can return this for further handling
            } else if (error.request) {
                console.error("No Response received:", error.request); // The request was made but no response was received
            } else console.error("Error Message:", error.message); // Something happened while setting up the request
        });
    return PostApiData;
}

export function PostTokenApi(path, body) {
    let tokenData;
    if (localStorage.getItem("accessToken")) {
        tokenData = "Bearer " + localStorage.getItem("accessToken");
    } else {
        tokenData = "";
    }
    let headers = { Authorization: tokenData };
    const PostApiData = axios
        .post(path, body, { headers: headers })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            if (error.message === "Network Error") {
                localStorage.removeItem("accessToken");
                window.location.href = "/";
            }
            return error.response;
        });
    return PostApiData;
}

export function PutApi(path, body) {
    const PutApiData = axios
        .put(path, body)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
        });

    return PutApiData;
}
export function PutTokenApi(path, body) {
    let tokenData;
    if (localStorage.getItem("accessToken")) {
        tokenData = "Bearer " + localStorage.getItem("accessToken");
    } else {
        tokenData = "";
    }
    let headers = { Authorization: tokenData };
    const PutApiData = axios
        .put(path, body, { headers: headers })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            if (error.message === "Network Error") {
                localStorage.removeItem("accessToken");
                window.location.href = "/";
            }
            return error.response;
        });
    return PutApiData;
}
export function deleteApi(path, body) {
    const DeleteApiData = axios
        .delete(path, body)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
        });

    return DeleteApiData;
}
export async function deleteTokenApi(path, body) {
    let tokenData = localStorage.getItem("accessToken") ? "Bearer " + localStorage.getItem("accessToken") : "";
    let headers = { Authorization: tokenData };
    try {
        const response = await axios.delete(path, {
            headers: headers,
            data: body, // Correct way to send body in DELETE request
        });
        return response;
    } catch (error) {
        if (error.message === "Network Error") {
            localStorage.removeItem("accessToken");
            window.location.href = "/";
        }
        return error.response;
        // if (error.response) {
        //     return error.response;
        // } else {
        // }
    }
}

// export function PostApi(path, body) {
//     const PostApiData = axios
//         .post(path, body, {
//             headers: {
//                 'Content-Type': 'application/json'  // Ensure the header is set to application/json
//             }
//         })
//         .then((response) => {
//             return response;
//         })
//         .catch((error) => {
//         });

//     return PostApiData;
// }
//
